"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlipHorizontal = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const blockClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    d: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    pad: 0,
    mar: 0,
    bd: 0,
    bg: 'none',
    out: 0,
    appearance: 'none',
    userSelect: 'none',
    lineHeight: 0,
    perspective: '800px',
    transformStyle: 'preserve-3d',
    verticalAlign: 'middle',
    trs: 'transform .3s',
    'button:active &, a:active &': {
        transform: 'rotateY(180deg)',
    },
    '&:focus-visible': {
        out: 0,
    },
});
const faceClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    backfaceVisibility: 'visible',
    transformStyle: 'preserve-3d',
    willChange: 'transform',
});
const FlipHorizontal = ({ children, duration = 280, disabled, className = '', style, onClick, ...rest }) => {
    const Component = onClick ? 'button' : 'span';
    return (React.createElement(Component, { ...rest, className: className + blockClass, style: style, onClick: disabled ? undefined : onClick, type: onClick ? 'button' : undefined, disabled: onClick ? disabled : undefined, "aria-disabled": !onClick && disabled ? true : undefined },
        React.createElement("span", { className: faceClass }, children)));
};
exports.FlipHorizontal = FlipHorizontal;
exports.default = exports.FlipHorizontal;
